import { Link } from 'react-router-dom';
import useResize from '@/hooks/useResize';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from '@/layout';
import PageContainer from '@/components/Container/PageContainer';
import InnerPageTitle from '@/components/UI/InnerPageTitle';
import { Button } from '@/components/UI/Button';
import { Main, InformationWrapper, SidebarWrapper, InfoTitle, ContentWrapper, LinkText } from './style';
import useCurrentLang from '@/hooks/useCurrentLang';


const WhatIsCR = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isTablet, isMobile } = useResize();

  return (
    <Main isTablet={isTablet} isMobile={isMobile}>
      <PageContainer
        title={
          <InnerPageTitle
            link={'/'}
            subtitle={t('pages.whatIsCR.title')}
          />
        }
        centerContent={true}
      >
        <ContentWrapper isTablet={isTablet} isMobile={isMobile}>
          <Content />
          <SideBar />
        </ContentWrapper>
      </PageContainer>
    </Main>
  );
}

const Content = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isTablet, isMobile } = useResize();
  const secondpartList = t('pages.whatIsCR.content.secondPart.li', { returnObjects: true }) as string[];
  const thirdPartList = t('pages.whatIsCR.content.thirdPart.li', { returnObjects: true }) as string[];

  return (
    <InformationWrapper isMobile={isMobile} isTablet={isTablet}>
      <img width="100%" src="/images/whatIsCR/whatIsCR.png" alt="" />
      <Box paddingTop={30}>
        {t('pages.whatIsCR.content.firstPart.1')}
        <br />
        <br />
        {t('pages.whatIsCR.content.firstPart.2')}
        <br />
        <br />
        {t('pages.whatIsCR.content.firstPart.3')}
      </Box>
      <Box paddingTop={30}>
        <InfoTitle>
          {t('pages.whatIsCR.content.secondPart.title')}
        </InfoTitle>
        <ul>
          {
            secondpartList.map((item, index) => (
              <li key={index}>
                {item}
              </li>
            ))
          }
        </ul>
      </Box>
      <Box paddingTop={30}>
        <InfoTitle>
          {t('pages.whatIsCR.content.thirdPart.title')}
        </InfoTitle>
        <ul>
          {
            thirdPartList.map((item, index) => (
              <li key={index}>
                {item}
              </li>
            ))
          }
        </ul>
      </Box>

      <Box paddingTop={30}>
        {t('pages.whatIsCR.content.fourthPart.1')}
        <br />
        <br />
        {t('pages.whatIsCR.content.fourthPart.2')}
      </Box>
    </InformationWrapper >
  )
}

const SideBar = () => {
  // @ts-ignore
  const { t } = useTranslation();
  const { isTablet, isMobile } = useResize();
  const currentLang = useCurrentLang();

  const sidebarLinks = t('pages.whatIsCR.sidebarLinks.links', { returnObjects: true });

  return (
    <SidebarWrapper isMobile={isMobile} isTablet={isTablet}>
      <div className="card">
        <Flex flexDirection={'column'} gridGap={'10px'}>
          <Link to={`/${currentLang}/guest/creditReport?step=1`}>
            <Button
              width={'100%'}
              size={'lg'}
              variant={'primary'}
              rounded={false}
            >
              {t('buttons.buyAReport')}
            </Button>
          </Link>
          <Link to={`/${currentLang}/About#Contact`}>
            <Button
              width={'100%'}
              size={'lg'}
              variant={'primary-invert'}
              rounded={false}
            >
              {t('buttons.contactUs')}
            </Button>
          </Link>
        </Flex>
      </div>
      <div className="card">
        <InfoTitle>
          {t('pages.whatIsCR.sidebarLinks.title')}
        </InfoTitle>
        <Flex flexDirection={'column'} gridGap={'10px'}>
          {
            sidebarLinks.map((item, index) => (
              <a href={item.url} key={index} target="_blank" rel="noreferrer">
                <LinkText>
                  {item.name}
                </LinkText>
              </a>
            ))
          }
        </Flex>
      </div>
    </SidebarWrapper>
  );

}

export default WhatIsCR;